/**
 * Converts a readonly array of strings into a record where each string
 * becomes both a key and its corresponding value.
 * Useful for creating type-safe enum-like objects from const arrays.
 *
 * @example
 * const fruits = ["apple", "banana"] as const;
 * const fruitRecord = arrayToRecord(fruits);
 * // Result: { apple: "apple", banana: "banana" }
 * // Type: { apple: "apple"; banana: "banana" }
 */
export function arrayToRecord<T extends readonly string[]>(
  values: T
): { [K in T[number]]: K } {
  const result: Record<string, string> = {};
  for (const value of values) {
    result[value] = value;
  }
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TypeScript cannot infer the mapped type from a dynamic loop
  return result as { [K in T[number]]: K };
}
